
import React from 'react';
import { Plus } from 'lucide-react';

interface MindMapContextMenuProps {
  x: number;
  y: number;
  visible: boolean;
  onAddNode: (event: React.MouseEvent) => void;
  onClose: () => void;
}

export default function MindMapContextMenu({
  x,
  y,
  visible,
  onAddNode,
  onClose,
}: MindMapContextMenuProps) {
  if (!visible) return null;

  const handleAddNode = (event: React.MouseEvent) => {
    event.stopPropagation();
    onAddNode(event);
  };

  return (
    <div
      className="fixed z-50 min-w-[8rem] overflow-hidden rounded-md border bg-white shadow-lg"
      style={{
        left: x,
        top: y,
        transform: 'translate(-50%, -10px)', // Center horizontally and offset slightly up
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="p-1">
        <div
          className="relative flex cursor-pointer select-none items-center rounded-sm px-3 py-2 text-sm outline-none hover:bg-blue-50 hover:text-blue-600 transition-colors"
          onClick={handleAddNode}
        >
          <Plus className="w-4 h-4 mr-2" />
          Adicionar Nova Ideia
        </div>
      </div>
    </div>
  );
}
